import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Form} from 'formik';
import moment from 'moment';
import FieldDatepicker from '../../components/FieldDatepicker/FieldDatepicker';
import Button from '../../components/Button';
import styles from './styles.module.scss';

const Step10View = () => {
  const today = moment();
  const getMinDate = today => {
    return moment(today).date(1).month(0).toDate();
  };
  const getMaxDate = today => {
    const isDecemberToday = moment(today).month() === 11;
    const nextYear = moment(today).add({year: 1});
    return isDecemberToday ? nextYear.toDate() : today.toDate();
  };

  return (
    <Form className={styles.formContainer}>
      <div className={styles.input}>
        <div className={styles.titleBold}>
          <FormattedMessage
            id="step10.form.title"
          />
        </div>
      </div>
      <FieldDatepicker
        fieldId='taxYear'
        showYearPicker
        dateFormat="yyyy"
        minDate={getMinDate(today)}
        maxDate={getMaxDate(today)}
        popperPlacement="auto-end"
        containerStyles={`${styles.input} ${styles.yearpicker}`}
        yearItemNumber={6}
        label={(
          <FormattedMessage
            id="step10.form.year.label"
            defaultMessage="Tax year:"
          />
        )}
      />
      <div className={`${styles.text} ${styles.input} ${styles.title}`}>
        <FormattedMessage
          id={'step10.form.note.title'}
          defaultMessage={'The explanation should be read carefully'}
        />
      </div>
      <div className={`${styles.text} ${styles.input} ${styles.bigMargin}`}>
        <FormattedMessage
          id={'step10.form.note.1'}
          defaultMessage={'Every employee must fill out Form 101 according to the state tax regulations. The information in this form is used by us to issue a pay slip for you and gives us permission to give you tax breaks and to make tax calculations.'}
        />
      </div>
      <div className={`${styles.text} ${styles.input} ${styles.bold} ${styles.bigMargin}`}>
        <FormattedMessage
          id={'step10.form.note.2'}
          defaultMessage={'Form 101 is an annual, every year the employee will remind you (fill out Form 101 for income tax).'}
        />
      </div>

      <Button
        type='submit'
        label={(
          <FormattedMessage
            id='common.form.button.save'
            defaultMessage='Save'
          />
        )}
      />
    </Form>
  )
};

export default Step10View;
